import { Email, ZipCode } from '@hc-frontend/core-types';
import { z } from 'zod';

export const ZIP_CODE = 'ZIP_CODE';
export const HOUSEHOLD_INCOME = 'HOUSEHOLD_INCOME';
export const HOUSEHOLD_SIZE = 'HOUSEHOLD_SIZE';
export const DOB = 'DOB';
export const TOBACCO = 'TOBACCO';
export const EMAIL = 'EMAIL';

export const ANSWERS = [
  ZIP_CODE,
  HOUSEHOLD_INCOME,
  HOUSEHOLD_SIZE,
  DOB,
  TOBACCO,
  EMAIL,
] as const;

export type Answers = (typeof ANSWERS)[number];

export const ZIP_CODE_SCHEMA = ZipCode;
export type ZipCodeType = z.infer<typeof ZIP_CODE_SCHEMA>;

export const HOUSEHOLD_INCOME_SCHEMA = z.number().min(1);
export type HouseholdIncomeType = z.infer<typeof HOUSEHOLD_INCOME_SCHEMA>;

export const HOUSEHOLD_SIZE_SCHEMA = z.number().min(1).max(5);
export type HouseholdSizeType = z.infer<typeof HOUSEHOLD_SIZE_SCHEMA>;

export const DOB_SCHEMA = z.string();
export type DobType = z.infer<typeof DOB_SCHEMA>;

export const TOBACCO_SCHEMA = z.union([z.literal(0), z.literal(1)]);
export type TobaccoType = z.infer<typeof TOBACCO_SCHEMA>;

export const EMAIL_SCHEMA = Email;
export type EmailType = z.infer<typeof EMAIL_SCHEMA>;

export const AnswersObjectSchema = z
  .object({
    ZIP_CODE: ZIP_CODE_SCHEMA,
    HOUSEHOLD_INCOME: HOUSEHOLD_INCOME_SCHEMA,
    HOUSEHOLD_SIZE: HOUSEHOLD_SIZE_SCHEMA,
    DOB: DOB_SCHEMA,
    TOBACCO: TOBACCO_SCHEMA,
    EMAIL: EMAIL_SCHEMA,
  })
  .partial();

export type AnswersObject = z.infer<typeof AnswersObjectSchema>;

export type ResultStatus = 'idle' | 'loading' | 'success' | 'error';
